import Vue from 'vue'
import App from './App.vue'
import vSelect from 'vue-select'
import Vuelidate from 'vuelidate'
import UIkit from 'uikit/dist/js/uikit'

window.UIkit = UIkit

Vue.config.productionTip = false
Vue.component('v-select', vSelect)
Vue.use(Vuelidate)

new Vue({
  render: h => h(App)
}).$mount('#app')
